import queryString from "app/services/queryStringService";
import { memo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import { Breadcrumb } from "@gull";
import {
  addUpdateAirlines,
  getSupplierCommissionList,
  getVendorSearchForAdd,
} from "app/services/vendorService";
import moment from "moment";
import Tooltip from "rc-tooltip";
import {
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  Image,
  Row,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { MdAddBox, MdEdit, MdSearch } from "react-icons/md";
import Swal from "sweetalert2";

import { getUserGroup } from "app/services/userGroupService";
import { NotificationManager } from "react-notifications";
import AddUpdateCommission from "./Components/AddUpdateCommission";
import { FaInfoCircle } from "react-icons/fa";
import CommissionDetails from "./Components/CommissionDetails";

const SupplierCommissionList = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userSearch, setUserSearch] = useState("");
  const [userGroupId, setUserGroupId] = useState(0);
  const [supplierId, setSupplierId] = useState(0);
  const [show, setShow] = useState(false);
  const [initialValues, setInitialValues] = useState({
    id: 0,
    supplierId: 0,
    carrierId: 0,
    groupId: 0,
    fullRowStatus: true,
    fareName: "",
    fare: {
      commissionType: "percentage",
      commissionValue: 0,
      markupType: "percentage",
      markupValue: 0,
      typeStatus: true,
    },
    food: {
      commissionType: "percentage",
      commissionValue: 0,
      markupType: "percentage",
      markupValue: 0,
      typeStatus: true,
    },
    seat: {
      commissionType: "percentage",
      commissionValue: 0,
      markupType: "percentage",
      markupValue: 0,
      typeStatus: true,
    },
    baggage: {
      commissionType: "percentage",
      commissionValue: 0,
      markupType: "percentage",
      markupValue: 0,
      typeStatus: true,
    },
  });
  const [row, setRow] = useState(null);
  const [userGroupDetails, setUserGroupDetails] = useState(null);
  const [SupplierDetails, setSupplierDetails] = useState(null);
  const [edit, setEdit] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showCommissionModal, setShowCommissionModal] = useState(false);

  const handleCloseCommissionModal = () => setShowCommissionModal(false);
  const handleShowCommissionModal = () => setShowCommissionModal(true);

  const editHandler = (values) => {
    debugger;
    setEdit(true);
    setRow(values);
    setInitialValues({
      id: values.id,
      supplierId: values.supplierId,
      carrierId: values.carrierId,
      groupId: values.groupId,
      fullRowStatus: values.fullRowStatus,
      fareName: values.fareName,
      fare: {
        commissionType: values.fareCommissionType,
        commissionValue: values.fareCommissionValue,
        markupType: values.fareMarkupType,
        markupValue: values.fareMarkupValue,
        typeStatus: values.fareTypeStatus,
      },
      food: {
        commissionType: values.foodCommissionType,
        commissionValue: values.foodCommissionValue,
        markupType: values.foodMarkupType,
        markupValue: values.foodMarkupValue,
        typeStatus: values.foodTypeStatus,
      },
      seat: {
        commissionType: values.seatCommissionType,
        commissionValue: values.seatCommissionValue,
        markupType: values.seatMarkupType,
        markupValue: values.seatMarkupValue,
        typeStatus: values.seatTypeStatus,
      },
      baggage: {
        commissionType: values.baggageCommissionType,
        commissionValue: values.baggageCommissionValue,
        markupType: values.baggageMarkupType,
        markupValue: values.baggageMarkupValue,
        typeStatus: values.baggageTypeStatus,
      },
    });

    handleShow();
  };
  const commissionHandler = (values) => {
    setInitialValues({
      id: values.id,
      supplierId: values.supplierId,
      carrierId: values.carrierId,
      groupId: values.groupId,
      fullRowStatus: values.fullRowStatus,
      fareName: values.fareName,
      fare: {
        commissionType: values.fareCommissionType,
        commissionValue: values.fareCommissionValue,
        markupType: values.fareMarkupType,
        markupValue: values.fareMarkupValue,
        typeStatus: values.fareTypeStatus,
      },
      food: {
        commissionType: values.foodCommissionType,
        commissionValue: values.foodCommissionValue,
        markupType: values.foodMarkupType,
        markupValue: values.foodMarkupValue,
        typeStatus: values.foodTypeStatus,
      },
      seat: {
        commissionType: values.seatCommissionType,
        commissionValue: values.seatCommissionValue,
        markupType: values.seatMarkupType,
        markupValue: values.seatMarkupValue,
        typeStatus: values.seatTypeStatus,
      },
      baggage: {
        commissionType: values.baggageCommissionType,
        commissionValue: values.baggageCommissionValue,
        markupType: values.baggageMarkupType,
        markupValue: values.baggageMarkupValue,
        typeStatus: values.baggageTypeStatus,
      },
    });

    handleShowCommissionModal();
  };
  const userHandler = async () => {
    const userDetails = await getUserGroup();
    setUserGroupDetails(
      userDetails.data.data.map((item) => {
        return { value: item.id, label: item.name };
      }),
    );
    setUserGroupId(userDetails.data.data[0].id);
  };
  const supplierHandler = async () => {
    const response = await getVendorSearchForAdd();

    setSupplierDetails(
      response.data.data.map((item) => {
        return { value: item.id, label: item.supplierName };
      }),
    );
    setSupplierId(response.data.data[0].id);
  };
  const carrierInfo = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        <Image
          src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
          alt=""
          height="20"
          width={"20"}
          style={{ marginRight: 3, borderRadius: 15 }}
        />
        {row.flightCarrier.flightCarrierName}
      </div>
    );
  };
  const dateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        <div>{moment(cell).format("DD-MM-YYYY")}</div>
        <div>{moment(cell).format("HH:mm a")}</div>
      </div>
    );
  };

  const statusFormatter = (cell, row) => {
    if (row?.fullRowStatus == true) {
      return <div className="text-success">Active</div>;
    } else {
      return <div className="text-danger">Inactive</div>;
    }
  };
  const supplierName = (call, row) => {
    return <div>{row.supplierMaster.supplierName}</div>;
  };
  const fareName = (call, row) => {
    return <div>{row.fareName}</div>;
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item onClick={() => editHandler(row)}>
            <MdEdit className="text-primary me-4" size={15}></MdEdit>
            Edit
          </Dropdown.Item>

          <Dropdown.Item onClick={() => commissionHandler(row)}>
            <FaInfoCircle
              className="text-primary me-4"
              size={15}
            ></FaInfoCircle>
            Commission Details
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };
  const columns = [
    {
      dataField: "id",
      text: "Action",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "supplierEntryDate",
      text: "Created On",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "supplierModifyDate",
      text: "Modified On",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "supplierName",
      text: "Supplier Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: supplierName,
    },
    {
      dataField: "fareName",
      text: "Fare Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: fareName,
    },
    {
      dataField: "carrierId",
      text: "Carrier Info",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: carrierInfo,
    },
    {
      dataField: "fullRowStatus",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: statusFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadCommission = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      searchText: userSearch,
      userGroupId,
      supplierId,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getSupplierCommissionList(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };
  useEffect(() => {
    userHandler();
    supplierHandler();
  }, []);

  useEffect(() => {
    if (userGroupId && supplierId) {
      loadCommission();
    }
  }, [page, sizePerPage, userSearch, userGroupId, supplierId]);
  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    // setTimeout(async () => {
    //   await loadCommission();
    // }, 10);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "userSearch":
        setUserSearch(value);
        break;
      case "userGroupId":
        setUserGroupId(value);
        break;
      case "supplierId":
        setSupplierId(value);
        break;

      default:
        break;
    }
  };
  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await loadCommission();
    }, 10);
  };

  const refreshFilter = async (e) => {
    setUserSearch("");
    setUserGroupId(0);
    setSupplierId(0);
    setTimeout(async () => {
      await loadCommission();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option, index) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={index}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Supplier Fare Commission List</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Supplier Fare Commission List" }]}
      ></Breadcrumb>
      <Row className="mb-2">
        <Col
          lg={12}
          xs={12}
          style={{
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Button className="btn-md" variant="primary" onClick={handleShow}>
            <MdAddBox size={20} />
            Add Commission
          </Button>
        </Col>
      </Row>

      <div className="card card-body mb-3 ">
        <Row className="mb-2">
          <Col lg={3} xs={12}>
            {/* Full width on extra small screens, half on large screens */}
            <label className="pb-1">Search</label>
            <div>
              <input
                type="text"
                className="form-control"
                name="userSearch"
                value={userSearch}
                placeholder="Search"
                onChange={handleSearchChanges}
              />
            </div>
          </Col>
          <Col lg={3} xs={12}>
            {/* Full width on extra small screens, half on large screens */}
            <label className="pb-1">Supplier Name</label>
            <div>
              <select
                className="form-select"
                name="supplierId"
                placeholder="Supplier Name"
                value={supplierId}
                onChange={handleSearchChanges}
              >
                {SupplierDetails?.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </Col>
          <Col lg={3} xs={12}>
            {/* Full width on extra small screens, half on large screens */}
            <label className="pb-1">User Group</label>
            <div>
              <select
                className="form-select"
                name="userGroupId"
                placeholder="User Group"
                value={userGroupId}
                onChange={handleSearchChanges}
              >
                {userGroupDetails?.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </Col>

          <Col lg={3} xs={12}>
            {/* Full width on extra small screens, half on large screens */}
            <div className="d-flex justify-content-end pt-4">
              <button
                className="btn btn-outline-primary d-flex align-items-center"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>

              <button
                className="btn btn-outline-primary d-flex align-items-center ms-3"
                onClick={refreshFilter}
              >
                Refresh
              </button>
            </div>
          </Col>
        </Row>

        <div style={{ overflow: "auto" }}>
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
        <AddUpdateCommission
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          show={show}
          handleClose={handleClose}
          edit={edit}
          loadCommission={loadCommission}
          setEdit={setEdit}
          row={row}
        />
        <CommissionDetails
          initialValues={initialValues}
          show={showCommissionModal}
          handleClose={handleCloseCommissionModal}
        />
      </div>
    </>
  );
};

export default memo(SupplierCommissionList);
